<template>
  <div v-show="tablePagination && tablePagination.last_page > 1" class="pagination">
    <ul class="pagination-list">
      <li class="pagination-list-item">
        <span class="pagination-list-item-element" @click="loadPage('prev')"
          :class="['btn-nav', css.linkClass, isOnFirstPage ? css.disabledClass : '']">←</span>
      </li>
      <template v-if="notEnoughPages">
        <template v-for="n in totalPage">
          <li class="pagination-list-item">
            <span class="pagination-list-item-element" @click="loadPage(n)"
              :class="[css.pageClass, isCurrentPage(n) ? css.activeClass : '']"
              v-html="n">
            </span>
          </li>
        </template>
      </template>
      <template v-else>
        <template v-for="n in windowSize">
          <li class="pagination-list-item">
            <span class="pagination-list-item-element" @click="loadPage(windowStart+n-1)"
              :class="[css.pageClass, isCurrentPage(windowStart+n-1) ? css.activeClass : '']"
              v-html="windowStart+n-1">
            </span>
          </li>
        </template>
      </template>
      <li class="pagination-list-item">
        <span class="pagination-list-item-element" @click="loadPage('next')"
          :class="['btn-nav', css.linkClass, isOnLastPage ? css.disabledClass : '']">→</span>
      </li>
    </ul>
  </div>
</template>

<script>
/* eslint-disable */
import PaginationMixin from './VuetablePaginationMixin.vue'

export default {
  mixins: [PaginationMixin]
}
</script>



// WEBPACK FOOTER //
// src/components/vuetable/VuetablePagination.vue